import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ColumnConfig } from 'material-dynamic-table';

@Component({
  selector: 'app-saved-carts-list-name-cell',
  templateUrl: './saved-carts-list-name-cell.component.html',
  styleUrls: ['./saved-carts-list-name-cell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SavedCartsListNameCellComponent implements OnInit {
  @Input() column: ColumnConfig;
  @Input() row: any;

  constructor() {}

  ngOnInit() {}
}
